import { OrderPointType } from '../enums/order-point-type';

export const LTL_ORDER_POINT_TYPES = [
  OrderPointType.LOADING,
  OrderPointType.UNLOADING,
];
